import React from 'react';
import './Footer.css'; // Create and use a separate CSS file for the footer styles

const Footer = () => {
  return (
    <footer className="footer">
      <a href="https://buy.hundredcoin.io" target="_blank" rel="noopener noreferrer">
      <img src="/Logo.png" alt="Logo" className="footer-logo" />
      </a>
      <p className="footer-slogan">#KeepIt<span className='emoji'>💯</span></p>
    </footer>
  );
};

export default Footer;
